export interface CookieParams {
    name: string;
    value: string;
    path?: string;
    domain?: string;
    duration?: number;
    secure?: boolean;
    sameSite?: 'lax' | 'strict' | 'none';
}

export class Cookie {
    public static set(params: CookieParams) {
        const { name, value, path, domain, duration, secure, sameSite } = params;
        const cookieAttributes: string[] = [];

        cookieAttributes.push(`${name}=${value};`);

        if (path) cookieAttributes.push(`path=${path}`);
        if (domain) cookieAttributes.push(`domain=${domain}`);
        if (duration) cookieAttributes.push(`max-age=${duration}`);
        if (secure) cookieAttributes.push('Secure');
        if (sameSite) cookieAttributes.push(`SameSite=${sameSite}`);

        document.cookie = cookieAttributes.join('; ');
    }

    public static delete(cookieName: string): void {
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
    }

    public static getValue(cookieName: string): string | null {
        const cookie = Cookie.find(cookieName);
        return cookie ? cookie.split('=')[1] : null;
    }

    public static clearAll(): void {
        const cookies = document.cookie.split('; ');

        cookies.forEach((cookie) => {
            const cookieName = cookie.split('=')[0];
            Cookie.delete(cookieName);
        });
    }

    private static find(cookieName: string): string | undefined {
        const cookies = document.cookie.split('; ');
        return cookies.find((row) => row.startsWith(`${cookieName}=`));
    }
}
